import gql from 'graphql-tag';

/**
 * Mutation to start an inspection instance.
 * Transitions an inspection instance from scheduled/draft status to in-progress.
 */
export const startInspectionInstanceMutation = gql`
  mutation startInspectionInstance($input: StartInspectionInstanceInput!) {
    startInspectionInstance(input: $input) {
      success
      newVersion
    }
  }
`;
